module.exports = __webpack_public_path__ + "files/487bd477014940691bbeb3c6aa7dc5c7.svg";